import AccordionHTML from "@components/accordions/accordionHTML";
import { Card } from "@components/cards/card";
import { ReactNode } from "react";
import { RaffleDefaultNumberHowItWorksBuying } from "./buying";
import { RaffleDefaultNumberHowItWorksDraws } from "./draws";

export function RaffleDefaultNumberHowItWorks() {
  const items: { title: string; html: ReactNode }[] = [
    {
      title: "A aquisição",
      html: RaffleDefaultNumberHowItWorksBuying(),
    },
    {
      title: "O sorteio",
      html: RaffleDefaultNumberHowItWorksDraws(),
    },
  ];

  return (
    <>
      <Card>
        <div className="card-header">
          <div className="card-title">Rifa Tradicional Numérica</div>
          <div className="card-category">
            Todo funcionamento e dúvidas frequentes sobre a Rifa Tradicional
            Numérica.
          </div>
        </div>
        <div className="card-body">
          {/* Titla */}
          <div className="col-md-12 text-center border-bottom pb-3">
            <span className="h5 fw-bold">Como Funciona?</span>
          </div>
          <div className="row">
            {/* Load the Explanations */}
            <AccordionHTML items={items} autoOpenKey={undefined} />
          </div>
        </div>
      </Card>
    </>
  );
}
